"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mouseInteractivity_ToolTip = exports.mouseInteractivity_PopUp = void 0;
exports.mouseInteractivity_PopUp = 'pop-up';
exports.mouseInteractivity_ToolTip = 'tool-tip';
